import { toast } from 'react-hot-toast';

import { unlockContentWithOauth } from '@utils/backend-api/oauth';
import { UnlockContentWithOauthParams } from '@utils/backend-api/oauth';

const useOauthUnlockContent = () => {
  const unlockContentViaOauth = async (values: UnlockContentWithOauthParams) => {
    try {
      const response = await unlockContentWithOauth(values);
      window.location.href = response.location;
    } catch (error) {
      toast.error(error.message);
    }
  };

  return { unlockContentViaOauth };
};

export default useOauthUnlockContent;
